/* eslint-disable no-console */

import { register } from 'register-service-worker';

const workerURL = `${import.meta.env.BASE_URL}service-worker.js`;

if (import.meta.env.PROD) {
  register(workerURL, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB',
      );
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    /**
     * @description Обработчик замены ранее установленного SW (перерегистрация).
     * @returns {void}
     * @link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration/updatefound_event
     */
    updatefound() {
      console.log('New content is downloading.');
    },
    /**
     * @description Обработчик изменения состояния ранее установленного SW.
     * @returns {void}
     * @link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/statechange_event
     */
    updated() {
      console.log('New content is available; please refresh.');
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
} else if ('serviceWorker' in navigator) navigator.serviceWorker.register('/dev-sw.js?dev-sw', { type: 'module' });
